export enum MessageTemplateList {
  DefaultMessageTemplateTab = 'DEV'
}
